import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
    type: 'transfer',
    transferInfos: {},
    list: {},
    transferList: [],
    transfersActiveError: false,
    isLoading: false,
    resetBulkSelectedRows: false,
    isUpdatedOrDeletedLoading: false,
    listTransferNoVolume: [],
    updatedBulkList: []
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
